namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmDruhZasilky extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmDruhZasilkyReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmDruhZasilkyObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmDruhZasilkyObj());
            this.detailObj.createBase({
                contentName: "detailAdmDruhZasilky",
                contentCaption: "jres:33000191", //RC 33000191 : Druh zásilky
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmDruhZasilky", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmDruhZasilkyObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmDruhZasilkyReadDto> {

        create() {
            this.data["gener_automat"] = 1;
        }

        textPopis(): string | undefined | null {
            return this.data["druh_zas_txt"]
        }

        setSxsDetail(): string {
            return this.data.druh_zas + "#";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmDruhZasilkySaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (data.NewRecord == true) 
                data.druh_zas = null;
            if (this.data["povol_sl"]) {
                if (this.data["povol_sl"].indexOf('#') >= 0) {
                    this.cnt.dialogs.confirm("jres:33000257", "jres:33000258").on("yes", () => { //RC 33000258 : Povolené služby obsahovali znak '#'. Přejete si ho ponechat mezi povolenými službami?
                        if (data.povol_sl == null || data.povol_sl == "")
                            data.povol_sl = "#"
                        else
                            data.povol_sl += ",#"
                        this.saveDataInternal(data, close)
                    }).on("no", () => {
                        this.saveDataInternal(data, close)
                    })
                } else {
                    this.saveDataInternal(data, close)
                }
            }
        }

        private saveDataInternal(data: Gordic.AdmIsl.Interface.GAdmDruhZasilkySaveDto, close: boolean) {
            (this.cnt.isl.AdmDruhZasilky.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmDruhZasilky", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmDruhZasilky.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.druh_zas_txt) ? this.data.druh_zas_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenSslDenik?.update({ visible: editMode == false })
        }

        createForm() {
            //this.MakeBoolField("gener_automat", {
            //    change: (ev, ctx) => {
            //        var fieldPostSluzba = this.cnt.element.findForms("{0}form".format(this.options.contentName)).findFields("druh_zas");
            //        if (ctx.value == true) {
            //            fieldPostSluzba.gfield("clear");
            //            fieldPostSluzba.gfield("setValidators", [])
            //            fieldPostSluzba.gfield("disable")
            //        } else {
            //            fieldPostSluzba.gfield("setValidators", [new Gordic.Validators.Required({ stopping: true }), new Gordic.Validators.Range({ min: 10000 })])
            //            fieldPostSluzba.gfield("enable")
            //        }
            //    }
            //});
            this.MakeField("druh_zas", {
                emptyValue: null,
                defaultValue: 0,
            });
            this.MakeField("druh_zas_txt");
            this.MakeField("druh_zas_zkr");
            this.MakeField("k_xml");
            this.MakeBoolField("favorite_komb", {
                change: (ev, ctx) => {
                    if (this.editMode == true) {
                        var form = this.cnt.findForms("{0}form".format(this.options.contentName));
                        var kombSl = form.findFields("povol_sl_komb")
                        var multiSl = form.findFields("povol_sl_multi")
                        if (ctx.value == true) {
                            this.data["favorite_komb"] = 1;
                            kombSl.gfield("enable");
                            multiSl.gfield("disable");
                        } else {
                            this.data["favorite_komb"] = 0;
                            kombSl.gfield("disable");
                            multiSl.gfield("enable");
                        }
                    }
                }
            })
            this.MakeSelectField("povol_sl_komb", Gordic.Prefabs.Select.admWflsksl(), {  // Prefab pro wflsksl
                model: function (op, dto, modelOptions) {
                    switch (op) {
                        case "apply":
                            if (dto["favorite_komb"] == 1) {
                                if (dto["povol_sl"])
                                    $(this).gfield("setValue", { komb_sluzeb: dto["povol_sl"]}, { valid: false })
                            }
                            break;
                        case "collect":
                            if (dto["favorite_komb"] == 1) {
                                var data = $(this).gfield("getValue");
                                if (data != null)
                                    dto["povol_sl"] = data.komb_sluzeb
                                else
                                    dto["povol_sl"] = "";
                            }
                            break;
                    }
                }
            });
            //if (this.data["povol_sl"] != "#") {
                this.MakeSelectField("povol_sl_multi", Gordic.Prefabs.Select.wflcpos(), {
                    multi: true,
                    dropdown: false,
                    itemWidth: "",
                    model: function (op, dto, modelOptions) {
                        switch (op) {
                            case "apply":
                                if (dto["favorite_komb"] == 0) {
                                    if (dto["povol_sl"]) {
                                        $(this).gfield("setValue", dto["povol_sl"].split(',').filter((sl) => { return sl != "#" }).map(obj => ({
                                            post_sluzba: parseInt(obj)
                                        })) ,{ valid: false })
                                    }
                                }
                                break;
                            case "collect":
                                if (dto["favorite_komb"] == 0) {
                                    var data = $(this).gfield("getValue");
                                    var dataArr: any[] = []
                                    data.forEach((item) => {
                                        dataArr.push(item.post_sluzba)
                                    })
                                    dataArr.sort((a, b) => { return a - b });
                                    dto["povol_sl"] = dataArr.join(',')
                                }
                                break;
                        }
                    }
                });
            //} else {
            //    this.MakeField("povol_sl");
            //}
            this.MakeBoolField("priz_zahr");
            this.MakeBoolField("priz_doruc");
            this.MakeField("filtr_format");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt())
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }
    }
}